import MenuModel from '../menu/menu-model';
import OwnerModel from '../owner/owner-model';
import UserModel from '../user/user-model';

export default class MenugroupModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    menu: any;
    menuCaption: string;
    accessowner: any;
    accessownerCaption: string;
    users: any;
    userCaption: string;
    icon: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.menu = datarow.menu?.data?.map((d: any) => new MenuModel(d));
        this.menuCaption = this.menu?.length===0? '' : this.menu?.[0]?.name + (this.menu?.length>1? ', ...': '');
        this.accessowner = datarow.accessowner?.data?.map((d: any) => new OwnerModel(d));
        this.accessownerCaption = this.accessowner?.length===0? '' : this.accessowner?.[0]?.name + (this.accessowner?.length>1? ', ...': '');
        this.users = datarow.user?.data?.map((d: any) => new UserModel(d));
        this.userCaption = this.users?.length===0? '' : this.users?.[0]?.name + (this.users?.length>1? ', ...': '');
        this.icon = datarow.icon || 'window';
                
    } 

    public static endPoint: string = 'menu-groups' 
    public static endPointFilterList = () => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' +owner);
    }  
    public static endPointFilter2 = () => {
        return (this.endPointFilterList2() + '&filters[id]=');
    }

    public static endPointFilterList2 = () => {
        const owner = OwnerModel.getOwner();
        const user = UserModel.getUser();
        return ( '?populate=*&sort=id&filters[status]=active&filters[$or][0][id]=1&filters[$or][1][accessowner][id]=' + owner + '&filters[$or][1][user][id]=' + user)
    } 
    public static url: string = '/menugroup';
    public static caption: string = 'Menu Group';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        menu: [],
        menuCaption: '',   
        accessowner: [{id: + (OwnerModel.getOwner()||0)}],
        accessownerCaption: '',   
        users: [],
        userCaption: '',   
        icon: 'window',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static columnPicklistCard = [
        { name: 'icon', type: 'icon' },
        { name: 'name', type: 'caption' },
        { name: 'description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}